<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->

<div class="status-dot-container">
  <div class="bullet" [class]="statusColor"></div>
  <span class="status-text" [class.bold]="bold">{{ status }}</span>
</div>
